import React from "react";
import "./styles.css";

const CustomTable = ({ 
  columns = [], 
  dataSource = [], 
  loading = false,
  pagination = true,
  size = "default",
  bordered = false,
  className = "",
  rowKey = "key"
}) => {
  if (loading) {
    return (
      <div className="custom-table-loading">
        <div className="custom-table-spinner"></div>
        <p>Carregando...</p>
      </div>
    );
  }

  const getRowKey = (record, index) => {
    if (typeof rowKey === "function") {
      return rowKey(record, index);
    }
    return record[rowKey] || index;
  };

  return (
    <div className={`custom-table-container ${className}`}>
      <table className={`custom-table ${size} ${bordered ? 'bordered' : ''}`}>
        <thead className="custom-table-thead">
          <tr>
            {columns.map((column, index) => (
              <th 
                key={column.key || column.dataIndex || index}
                className="custom-table-th"
                style={{ width: column.width }}
              >
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="custom-table-tbody">
          {dataSource.length === 0 ? (
            <tr>
              <td 
                colSpan={columns.length} 
                className="custom-table-empty"
              >
                Nenhum dado disponível
              </td>
            </tr>
          ) : (
            dataSource.map((record, index) => (
              <tr key={getRowKey(record, index)} className="custom-table-row">
                {columns.map((column, colIndex) => (
                  <td 
                    key={column.key || column.dataIndex || colIndex}
                    className="custom-table-td"
                  >
                    {column.render 
                      ? column.render(record[column.dataIndex], record, index)
                      : record[column.dataIndex]
                    }
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
      
      {pagination && dataSource.length > 0 && (
        <div className="custom-table-pagination">
          <span className="custom-table-pagination-info">
            Total: {dataSource.length} itens
          </span>
        </div>
      )}
    </div>
  );
};

export default CustomTable;
